export const meetingTypes = [
  { value: "custom",label: "Create Your Own" },
    { value: "job-interview", label: "Job Interview" },
    { value: "small-talk", label: "Small Talk" },
    { value: "sales-call", label: "Sales Call" },
    { value: "performance-review", label: "Performance Review" },
    { value: "client-presentation", label: "Client Presentation" },
    { value: "team-meeting", label: "Team Meeting" },
    { value: "networking", label: "Networking Event" },
    { value: "ielts-speaking-interview", label: "IELTS Speaking" },
    { value: "customer-support", label: "Customer Support" },
    { value: "recruiting", label: "Recruiting" },              // NEW
    { value: "debate", label: "Debate" },

  ];
  
  export const industries = [
    { value: 'custom', label: "Create Your Own" },
        { value: 'not-applicable', label: 'Not Applicable' },
    { value: 'technology', label: 'Technology' },
    { value: 'healthcare', label: 'Healthcare' },
    { value: 'finance', label: 'Finance' },
    { value: 'education', label: 'Education' },
    { value: 'retail', label: 'Retail' },
    { value: 'manufacturing', label: 'Manufacturing' },
    { value: 'consulting', label: 'Consulting' },
    { value: 'real-estate', label: 'Real Estate' },
    { value: 'hospitality', label: 'Hospitality' },
    { value: 'automotive', label: 'Automotive' },
    { value: 'energy', label: 'Energy' },
    { value: 'telecommunications', label: 'Telecommunications' },
    { value: 'media', label: 'Media & Entertainment' },
    { value: 'pharmaceuticals', label: 'Pharmaceuticals' },
    { value: 'agriculture', label: 'Agriculture' },
    { value: 'construction', label: 'Construction' },
    { value: 'logistics', label: 'Logistics & Transportation' },
    { value: 'government', label: 'Government' },
    { value: 'non-profit', label: 'Non-Profit' },
    { value: 'marketing', label: 'Marketing' },        // NEW
    { value: 'human-resources', label: 'Human Resources' }, // NEW
    { value: 'cybersecurity', label: 'Cybersecurity' },
    { value: 'debate-public-speaking', label: 'Debate & Public Speaking' },
  
  ];

export const voices = [
  { value: 'cedar', label: 'Male' },
  { value: 'marin', label: 'Female' },
];

export const languageOptions = [
  { value: "English", label: "English", transcriptionCode: "en" },
  { value: "Spanish", label: "Spanish", transcriptionCode: "es" },
  { value: "French", label: "French", transcriptionCode: "fr" },
  { value: "German", label: "German", transcriptionCode: "de" },
  { value: "Italian", label: "Italian", transcriptionCode: "it" },
  { value: "Portuguese", label: "Portuguese", transcriptionCode: "pt" },
  { value: "Dutch", label: "Dutch", transcriptionCode: "nl" },
  { value: "Arabic", label: "Arabic", transcriptionCode: "ar" },
  { value: "Hindi", label: "Hindi", transcriptionCode: "hi" },
  { value: "Chinese (Mandarin)", label: "Chinese (Mandarin)", transcriptionCode: "zh" },
  { value: "Japanese", label: "Japanese", transcriptionCode: "ja" },
  { value: "Korean", label: "Korean", transcriptionCode: "ko" },
];

const languageCodeByLabel = languageOptions.reduce((acc, option) => {
  acc[option.value] = option.transcriptionCode;
  return acc;
}, {});

export const getTranscriptionLanguageCode = (languageLabel) => {
  const label = String(languageLabel || "English");
  return languageCodeByLabel[label] || "en";
};

export const aiBehaviors = [
  { value: 'professional', label: 'Professional & Polite', help: 'Formal tone, respectful, stays on agenda.', bgColor: 'bg-purple-100', textColor: 'text-purple-800' },
  { value: 'reserved', label: 'Reserved', help: 'Brief answers, low emotion, minimal small talk.', bgColor: 'bg-slate-100', textColor: 'text-slate-800' },
  { value: 'challenging', label: 'Challenging (High Bar)', help: 'Pushes back and asks hard questions.', bgColor: 'bg-red-100', textColor: 'text-red-800' },
  { value: 'supportive', label: 'Supportive', help: 'Affirming, collaborative, solutions-focused.', bgColor: 'bg-blue-100', textColor: 'text-blue-800' },
  { value: 'assertive', label: 'Assertive', help: 'Confident, clear asks, guides the conversation.', bgColor: 'bg-violet-100', textColor: 'text-violet-800' },
  { value: 'easily-flustered', label: 'Easily Flustered', help: 'Loses track, needs reassurance and clarity.', bgColor: 'bg-orange-100', textColor: 'text-orange-800' },
  { value: 'impatient', label: 'Impatient / Time-Pressed', help: 'Wants quick answers; cuts to the chase.', bgColor: 'bg-amber-100', textColor: 'text-amber-800' },
  { value: 'blunt-rude', label: 'Blunt / Rude', help: 'Abrupt and dismissive; stress-tests composure.', bgColor: 'bg-rose-100', textColor: 'text-rose-800' },
  { value: 'nervous', label: 'Nervous', help: 'Hesitant, seeks validation; anxious wording.', bgColor: 'bg-cyan-100', textColor: 'text-cyan-800' },
  { value: 'awkward', label: 'Awkward / Socially Stiff', help: 'Odd pauses, misses cues; low social ease.', bgColor: 'bg-yellow-100', textColor: 'text-yellow-800' },
  { value: 'skeptical', label: 'Skeptical', help: 'Doubts claims; asks for proof and examples.', bgColor: 'bg-indigo-100', textColor: 'text-indigo-800' },
  { value: 'distracted', label: 'Distracted / Multitask', help: 'Attention drifts; needs concise hooks.', bgColor: 'bg-gray-100', textColor: 'text-gray-800' },
  { value: 'enthusiastic', label: 'Enthusiastic', help: 'High energy, positive, quick to agree.', bgColor: 'bg-fuchsia-100', textColor: 'text-fuchsia-800' },
  { value: 'detail-obsessed', label: 'Detail-Obsessed', help: 'Deep dives; wants specifics and numbers.', bgColor: 'bg-teal-100', textColor: 'text-teal-800' },
];

export const getGoalOptions = (type, role, industryType) => {
  const industryGoals = {
    'small-talk': {
      'colleague': {
        'default': [
          'Break the ice naturally',
          'Get comfortable talking',
          'Transition smoothly into work topics',
          'Keep conversation balanced and engaging',
        ],
      },
      'friend': {
        'default': [
          'Keep the conversation flowing',
          'Practice active listening',
          'Ask natural follow-up questions',
          'Wrap up warmly without awkwardness',
        ],
      },
      'classmate': {
        'default': [
          'Start casual conversation confidently',
          'Find shared interests quickly',
          'Practice clear and relaxed speaking',
          'Move into study-related topics naturally',
        ],
      },
      'neighbor': {
        'default': [
          'Make a friendly first impression',
          'Practice short everyday conversation',
          'Show warmth without overtalking',
          'Close the conversation politely',
        ],
      },
      'default': {
        'default': [
          'Build comfort in casual conversation',
          'Practice speaking naturally and clearly',
          'Improve question and follow-up flow',
          'End conversations smoothly',
        ],
      },
    },
    'job-interview': {
      'candidate': {
        'technology': ['Get software engineer offer', 'Learn about tech stack', 'Negotiate equity package', 'Understand development culture'],
        'healthcare': ['Secure healthcare role', 'Learn about patient care protocols', 'Understand compliance requirements', 'Discuss work-life balance'],
        'finance': ['Get financial analyst position', 'Learn about trading systems', 'Negotiate compensation package', 'Understand regulatory environment'],
        'consulting': ['Secure consultant role', 'Learn about client engagement', 'Understand travel requirements', 'Discuss career progression'],
        'education': ['Get teaching position', 'Learn about curriculum', 'Understand student demographics', 'Discuss professional development'],
        'retail': ['Secure retail management role', 'Learn about sales targets', 'Understand customer service standards', 'Discuss growth opportunities'],
        'default': ['Get the job offer', 'Learn about company culture', 'Negotiate salary and benefits', 'Showcase skills'],
      },
      'recruiter': {
        'technology': ['Assess coding skills', 'Evaluate system design knowledge', 'Determine cultural fit for tech team', 'Make hiring decision'],
        'healthcare': ['Assess medical knowledge', 'Evaluate patient care skills', 'Determine compliance understanding', 'Make hiring decision'],
        'finance': ['Assess financial analysis skills', 'Evaluate risk management knowledge', 'Determine regulatory understanding', 'Make hiring decision'],
        'consulting': ['Assess problem-solving skills', 'Evaluate client communication', 'Determine analytical thinking', 'Make hiring decision'],
        'education': ['Assess teaching methodology', 'Evaluate subject expertise', 'Determine student engagement skills', 'Make hiring decision'],
        'retail': ['Assess sales ability', 'Evaluate customer service skills', 'Determine leadership potential', 'Make hiring decision'],
        'default': ['Assess candidate fit', 'Evaluate skills', 'Determine cultural alignment', 'Make hiring decision'],
      },
    },
    'sales-call': {
      'salesperson': {
        'technology': ['Close software deal', 'Demonstrate technical value', 'Address integration concerns', 'Overcome security objections'],
        'healthcare': ['Close medical equipment sale', 'Demonstrate patient outcomes', 'Address compliance requirements', 'Overcome budget constraints'],
        'finance': ['Close financial services deal', 'Demonstrate ROI', 'Address regulatory concerns', 'Overcome risk objections'],
        'consulting': ['Close consulting engagement', 'Demonstrate expertise', 'Address scope concerns', 'Overcome pricing objections'],
        'education': ['Close educational service deal', 'Demonstrate learning outcomes', 'Address implementation concerns', 'Overcome budget constraints'],
        'retail': ['Close retail partnership', 'Demonstrate market potential', 'Address logistics concerns', 'Overcome margin objections'],
        'default': ['Close the deal', 'Book a demo', 'Generate leads', 'Overcome objections'],
      },
      'prospect': {
        'technology': ['Evaluate tech solution fit', 'Compare vendor capabilities', 'Understand implementation timeline', 'Assess technical support'],
        'healthcare': ['Evaluate medical solution', 'Compare safety records', 'Understand compliance support', 'Assess training requirements'],
        'finance': ['Evaluate financial solution', 'Compare risk profiles', 'Understand regulatory compliance', 'Assess integration complexity'],
        'consulting': ['Evaluate consulting approach', 'Compare methodologies', 'Understand deliverables', 'Assess team expertise'],
        'education': ['Evaluate educational solution', 'Compare learning outcomes', 'Understand implementation support', 'Assess scalability'],
        'retail': ['Evaluate retail solution', 'Compare market reach', 'Understand logistics support', 'Assess profitability'],
        'default': ['Evaluate solution fit', 'Compare options', 'Understand pricing', 'Assess vendor'],
      },
    },
    'recruiting': {
      'recruiter': {
        'default': [
          'Source qualified candidates',
          'Screen for skills & culture fit',
          'Align on hiring timeline',
          'Coordinate interviews',
        ],
      },
      'candidate': {
        'default': [
          'Understand role expectations',
          'Showcase relevant experience',
          'Clarify interview process',
          'Align compensation expectations',
        ],
      },
      'hiring-manager': {
        'default': [
          'Align on candidate profile',
          'Prioritize skills & must-haves',
          'Define interview loop plan',
          'Agree on decision criteria',
        ],
      },
    },
    'debate': {
      'debater': {
        'default': [
          'State your point in one clear sentence',
          'Give one strong fact or example',
          'Answer the other side directly',
          'End with a clear final point',
        ],
      },
      'moderator': {
        'default': [
          'Keep both speakers on topic',
          'Stop interruptions quickly',
          'Ask clear follow-up questions',
          'Keep time and move to the next point',
        ],
      },
    },
    'investor-meeting': {
      'founder': {
        'technology': ['Secure tech startup funding', 'Validate SaaS business model', 'Build relationships with VCs', 'Get strategic tech advice'],
        'healthcare': ['Secure medical startup funding', 'Validate health outcomes', 'Navigate regulatory landscape', 'Build healthcare partnerships'],
        'finance': ['Secure fintech funding', 'Validate financial model', 'Navigate compliance requirements', 'Build banking relationships'],
        'default': ['Secure funding', 'Build relationships', 'Validate business model', 'Get strategic advice'],
      },
      'investor': {
        'technology': ['Evaluate tech opportunity', 'Assess market disruption', 'Review technical capabilities', 'Determine valuation'],
        'healthcare': ['Evaluate health opportunity', 'Assess regulatory risks', 'Review clinical evidence', 'Determine market potential'],
        'finance': ['Evaluate fintech opportunity', 'Assess regulatory compliance', 'Review financial model', 'Determine risk profile'],
        'default': ['Evaluate opportunity', 'Assess market potential', 'Review team capabilities', 'Determine terms'],
      },
    },
  };

  const industrySpecific =
    industryGoals[type]?.[role]?.[industryType] ||
    industryGoals[type]?.[role]?.['default'];

  if (industrySpecific) return [...industrySpecific, 'Custom goal'];
  return ['Handle tough questions confidently', 'Build relationships', 'Communicate effectively', 'Custom goal'];
};

 export  const getRolesForMeetingType = (type) => {
    switch (type) {
      case 'small-talk':
        return [
          { value: 'custom', label: "Create Your Own" },
          { value: 'colleague', label: 'Colleague' },
          { value: 'friend', label: 'Friend' },
          { value: 'classmate', label: 'Classmate' },
          { value: 'neighbor', label: 'Neighbor' },
        ];
      case 'job-interview':
        return [
          { value: 'custom', label: "Create Your Own"},
          { value: 'candidate', label: 'Job Candidate' },
          { value: 'recruiter', label: 'Recruiter/Interviewer' },
      
        ];
      case 'sales-call':
        return [
          { value: 'custom', label:"Create Your Own" },
          { value: 'salesperson', label: 'Salesperson' },
          { value: 'prospect', label: 'Potential Customer' },
    
        ];
      case 'investor-meeting':
        return [
          { value: 'custom', label: "Create Your Own" },
          { value: 'founder', label: 'Founder/Entrepreneur' },
          { value: 'investor', label: 'Investor' },
   
        ];
        // NEW: Recruiting & Debate
    case 'recruiting':
      return [
        { value: 'recruiter', label: 'Recruiter' },
        { value: 'candidate', label: 'Candidate' },
        { value: 'hiring-manager', label: 'Hiring Manager' },
        { value: 'custom', label: 'Custom' },
      ];
    case 'debate':
      return [
        { value: 'debater', label: 'Debater' },
        { value: 'moderator', label: 'Moderator' },
      ];
      case 'client-presentation':
        return [
          { value: 'custom', label:"Create Your Own" },
          { value: 'presenter', label: 'Presenter' },
          { value: 'client', label: 'Client' },
        
        ];
      case 'performance-review':
        return [
          { value: 'custom', label: "Create Your Own" },
          { value: 'employee', label: 'Employee' },
          { value: 'manager', label: 'Manager' },
        
        ];
      case 'team-meeting':
        return [
          { value: 'custom', label: "Create Your Own" },
          { value: 'team-lead', label: 'Team Lead' },
          { value: 'team-member', label: 'Team Member' },
   
        ];
      case 'networking':
        return [
          { value: 'custom', label: "Create Your Own" },
          { value: 'networker', label: 'Active Networker' },
          { value: 'attendee', label: 'Event Attendee' },
 
        ];
      case 'ielts-speaking-interview':
        return [
          { value: 'custom', label: "Create Your Own" },
          { value: 'candidate', label: 'Test Candidate' },
          { value: 'examiner', label: 'Examiner' },
       
        ];
        case 'customer-support':
            return [
              { value: 'customer', label: 'Customer' },
              { value: 'customer-support-specialist', label: 'Customer Support Specialist' },
            ];
      case 'custom':
        return [
          { value: 'custom', label: "Create Your Own" }
        ];
      default:
        return [];
    }
  };
  
  export const getSpeakingWithOptions = (type, role) => {
    switch (type) {
      case 'small-talk':
        if (role === 'colleague') {
          return [
            { value: 'custom', label: "Create Your Own" },
            { value: 'teammate', label: 'Teammate' },
            { value: 'manager', label: 'Manager' },
            { value: 'cross-functional-peer', label: 'Cross-Functional Peer' },
          ];
        }
        if (role === 'friend') {
          return [
            { value: 'custom', label: "Create Your Own" },
            { value: 'close-friend', label: 'Close Friend' },
            { value: 'new-friend', label: 'New Friend' },
            { value: 'mutual-friend', label: 'Mutual Friend' },
          ];
        }
        if (role === 'classmate') {
          return [
            { value: 'custom', label: "Create Your Own" },
            { value: 'classmate', label: 'Classmate' },
            { value: 'study-partner', label: 'Study Partner' },
            { value: 'professor', label: 'Professor' },
          ];
        }
        if (role === 'neighbor') {
          return [
            { value: 'custom', label: "Create Your Own" },
            { value: 'neighbor', label: 'Neighbor' },
            { value: 'building-manager', label: 'Building Manager' },
            { value: 'community-member', label: 'Community Member' },
          ];
        }
        return [
          { value: 'custom', label: "Create Your Own" },
          { value: 'colleague', label: 'Colleague' },
          { value: 'friend', label: 'Friend' },
          { value: 'classmate', label: 'Classmate' },
        ];
      case 'job-interview':
        return role === 'candidate'
          ? [
            { value: 'custom', label: "Create Your Own" },
            { value: 'recruiter', label: 'Recruiter/Interviewer' },
            { value: 'hiring-manager', label: 'Hiring Manager' },
            { value: 'team-lead', label: 'Team Lead' },
           
          ]
          : [
            { value: 'custom', label: "Create Your Own" },
            { value: 'candidate', label: 'Job Candidate' },
            { value: 'intern-candidate', label: 'Intern Candidate' },
  
          ];
      case 'sales-call':
        return role === 'salesperson'
          ? [
            { value: 'custom', label: "Create Your Own" },
            { value: 'prospect', label: 'Potential Customer' },
            { value: 'decision-maker', label: 'Decision Maker' },

          ]
          : [
            { value: 'custom', label: "Create Your Own" },
            { value: 'salesperson', label: 'Sales Representative' },
            { value: 'account-manager', label: 'Account Manager' },
         
          ];
      case 'investor-meeting':
        return role === 'founder'
          ? [
            { value: 'custom', label: "Create Your Own" },
            { value: 'vc-partner', label: 'VC Partner' },
            { value: 'angel-investor', label: 'Angel Investor' },
            { value: 'investment-committee', label: 'Investment Committee' },
         
          ]
          : [
            { value: 'custom', label: "Create Your Own" },
            { value: 'founder', label: 'Founder/CEO' },
            { value: 'co-founder', label: 'Co-Founder' },
            { value: 'startup-team', label: 'Startup Team' },

          ];
          case 'customer-support':
            return role === 'customer'
              ? [
 
                { value: 'customer-support-specialist', label: 'Customer Support Specialist' },
              ]
              : [
                             
                { value: 'customer', label: 'Customer' },
           
              ];
      case 'client-presentation':
        return role === 'presenter'
          ? [
            { value: 'custom', label: "Create Your Own" },
            { value: 'client-stakeholder', label: 'Client Stakeholder' },
            { value: 'project-manager', label: 'Project Manager' },
      
          ]
          : [
            { value: 'custom', label: "Create Your Own" },
            { value: 'consultant', label: 'Consultant' },
            { value: 'service-provider', label: 'Service Provider' },
        
          ];

      case 'performance-review':
        return role === 'employee'
          ? [
            { value: 'custom', label: "Create Your Own" },
            { value: 'direct-manager', label: 'Direct Manager' },
            { value: 'hr-representative', label: 'HR Representative' },
    
          ]
          : [
            { value: 'custom', label: "Create Your Own" },
            { value: 'team-member', label: 'Team Member' },
            { value: 'direct-report', label: 'Direct Report' },
   
          ];
          case 'ielts-speaking-interview':
            return role === 'candidate'
              ? [
                { value: 'custom', label: "Create Your Own" },
                { value: 'examiner', label: 'IELTS Examiner' },
              ]
              : [
                { value: 'custom', label: "Create Your Own" },
                { value: 'candidate', label: 'Test Candidate' },
              ];
          case 'recruiting':
      if (role === 'recruiter') {
        return [
          { value: 'custom', label: "Create Your Own" },
          { value: 'candidate', label: 'Candidate' },
          { value: 'hiring-manager', label: 'Hiring Manager' },
          { value: 'recruiting-coordinator', label: 'Recruiting Coordinator' },
        ];
      }
      if (role === 'candidate') {
        return [
          { value: 'custom', label: "Create Your Own" },
          { value: 'recruiter', label: 'Recruiter' },
          { value: 'hiring-manager', label: 'Hiring Manager' },
          { value: 'interviewer', label: 'Interviewer' },
        ];
      }
      // hiring-manager or other roles in this flow
      return [
        { value: 'custom', label: "Create Your Own" },
        { value: 'recruiter', label: 'Recruiter' },
        { value: 'candidate', label: 'Candidate' },
        { value: 'recruiting-coordinator', label: 'Recruiting Coordinator' },
      ];

    case 'debate':
      return role === 'debater'
        ? [{ value: 'moderator', label: 'Moderator' }]
        : [{ value: 'debater', label: 'Debater' }];
      case 'custom':
        return [{ value: 'custom', label: "Create Your Own" }];
      default:
        return [
          { value: 'custom', label: "Create Your Own" },
          { value: 'colleague', label: 'Colleague' },
          { value: 'stakeholder', label: 'Stakeholder' },
      
        ];
    }
  };
